import { useEffect, useState } from "react";
import { toast } from "react-toastify";
import { get, post } from "../../controllers/apiController";
import Layout from "../../components/Layout";
import { Select2, Select2WColor } from "../../components/Select2";

const CustomerCreate = () => {
    const [customerName, setCustomerName] = useState("");
    const [companyName, setCompanyName] = useState("");
    const [customerEmail, setCustomerEmail] = useState("");
    const [customerPhone, setCustomerPhone] = useState("");
    const [etiketler, setEtiketler] = useState([]);
    const [hizmetEtiketler, setHizmetEtiketler] = useState([]);
    const [selectedEtiketler, setSelectedEtiketler] = useState([]);
    const [selectedHizmetEtiketler, setSelectedHizmetEtiketler] = useState([]);
    const [desc, setDesc] = useState("");
    const [loading, setLoading] = useState(true);

    const [source, setSource] = useState(null);

    const sources = [
        { value: "Meta", label: "Meta" },
        { value: "Manuel", label: "Manuel" },
        { value: "Ads", label: "Ads" },
        { value: "Landing Page", label: "Landing Page" },
        { value: "WordPress", label: "WordPress" },
        { value: "Referans", label: "Referans" },
        { value: "Eski Müşteri", label: "Eski Müşteri" },
        { value: "Mail", label: "Mail" }
    ];

    useEffect(() => {
        document.title = "Müşteri Ekle | LEVELUP CRM";

        const fetchAllData = async () => {
            await fetchEtiketler();
            await fetchHizmetEtiketler();
            setLoading(false);
        }

        fetchAllData();
    }, []);

    const fetchEtiketler = async () => {
        const res = await get("labels/");

        const etiketlerMapped = res.map(etiket => {
            return {
                value: etiket.Etiket_ID,
                label: etiket.Etiket_Adi,
                color: "#" + etiket.Etiket_Renk
            }
        });

        setEtiketler(etiketlerMapped);
    }

    const fetchHizmetEtiketler = async () => {
        const res = await get("service-labels/");

        const etiketlerMapped = res.map(etiket => {
            return {
                value: etiket.Hizmet_Etiket_ID,
                label: etiket.Etiket_Adi,
                color: "#" + etiket.Etiket_Renk
            }
        });

        setHizmetEtiketler(etiketlerMapped);
    }

    const createCustomer = async () => {
        if (customerName === "" || companyName === "" || customerEmail === "" || customerPhone === "" || selectedEtiketler.length === 0 || selectedHizmetEtiketler.length === 0 || !source) {
            toast.error("Tüm alanları doldurmalısınız!");
            return;
        }

        try {
            const response = await post("forms/create-customer", {
                nameSurname: customerName,
                companyName: companyName,
                source: source.value,
                email: customerEmail,
                phone: customerPhone,
                labels: selectedEtiketler.map(etiket => etiket.value),
                serviceLabels: selectedHizmetEtiketler.map(etiket => etiket.value),
                desc
            });

            setCustomerName("");
            setCompanyName("");
            setCustomerEmail("");
            setCustomerPhone("");
            setSelectedEtiketler([]);
            setSelectedHizmetEtiketler([]);
            setDesc("");
            setSource(null);

            toast.success("Müşteri başarıyla eklendi!");
        } catch (err) {
            toast.error("Müşteri oluşturulurken bir hata oluştu!");
        }
    }

    return (
        <Layout>
            <main className="nxl-container">
                <div className="nxl-content">
                    <div className="page-header">
                        <div className="page-header-left d-flex align-items-center">
                            <div className="page-header-title">
                                <h5 className="m-b-10">LEVELUP CRM</h5>
                            </div>
                            <ul className="breadcrumb">
                                <li className="breadcrumb-item"><a href="./">Anasayfa</a></li>
                                <li className="breadcrumb-item">Manuel Müşteri Oluştur</li>
                            </ul>
                        </div>
                    </div>
                    <div className="main-content">
                        <div className="row">
                            <div className="col-xxl-12 col-md-12">
                                <div className="card stretch stretch-full">
                                    <div className="card-body">
                                        <div class="mb-5 d-flex align-items-center justify-content-between">
                                            <h5 class="fw-bold mb-0 me-4">
                                                <span class="d-block mb-2">Müşteri Bilgileri:</span>
                                            </h5>
                                        </div>
                                        <div className="row mb-4 align-items-center">
                                            <div className="col-lg-4">
                                                <label for="customerName" className="fw-semibold">Adı Soyadı: </label>
                                            </div>
                                            <div className="col-lg-8">
                                                <div className="input-group">
                                                    <div className="input-group-text"><i className="feather-user"></i></div>
                                                    <input type="text" className="form-control" id="customerName" placeholder="Müşterinin adını soyadını giriniz." onChange={(e) => setCustomerName(e.target.value)} value={customerName} />
                                                </div>
                                            </div>
                                        </div>
                                        <div className="row mb-4 align-items-center">
                                            <div className="col-lg-4">
                                                <label for="companyName" className="fw-semibold">Firma Adı: </label>
                                            </div>
                                            <div className="col-lg-8">
                                                <div className="input-group">
                                                    <div className="input-group-text"><i className="feather-briefcase"></i></div>
                                                    <input type="text" className="form-control" id="companyName" placeholder="Varsa müşteri firma adını yazınız." onChange={(e) => setCompanyName(e.target.value)} value={companyName} />
                                                </div>
                                            </div>
                                        </div>
                                        <div className="row mb-4 align-items-center">
                                            <div className="col-lg-4">
                                                <label for="customerEmail" className="fw-semibold">E-Posta Adresi: </label>
                                            </div>
                                            <div className="col-lg-8">
                                                <div className="input-group">
                                                    <div className="input-group-text"><i className="feather-mail"></i></div>
                                                    <input type="text" className="form-control" id="customerEmail" placeholder="Müşteri e-posta adresini giriniz." onChange={(e) => setCustomerEmail(e.target.value)} value={customerEmail} />
                                                </div>
                                            </div>
                                        </div>
                                        <div className="row mb-4 align-items-center">
                                            <div className="col-lg-4">
                                                <label for="customerPhone" className="fw-semibold">Telefon Numarası: </label>
                                            </div>
                                            <div className="col-lg-8">
                                                <div className="input-group">
                                                    <div className="input-group-text"><i className="feather-phone"></i></div>
                                                    <input type="text" className="form-control" id="customerPhone" placeholder="Telefon numarasını başına 0 ekleyerek yazınız." onChange={(e) => setCustomerPhone(e.target.value)} value={customerPhone} />
                                                </div>
                                            </div>
                                        </div>
                                        <div className="row mb-4 align-items-center">
                                            <div className="col-lg-4">
                                                <label for="customerLabels" className="fw-semibold">Etiketler: </label>
                                            </div>
                                            <div className="col-lg-8">
                                                <div className="input-group">
                                                    <div className="input-group-text"><i className="feather-tag"></i></div>
                                                    <Select2WColor
                                                        value={selectedEtiketler}
                                                        key={"labelsSelect"}
                                                        options={etiketler}
                                                        isSearchable={true}
                                                        isClearable={true}
                                                        isMulti={true}
                                                        onChange={(e) => setSelectedEtiketler(e)}
                                                        style={{ flex: 1 }}
                                                    />
                                                </div>
                                            </div>
                                        </div>
                                        <div className="row mb-4 align-items-center">
                                            <div className="col-lg-4">
                                                <label for="customerServiceLabels" className="fw-semibold">Hizmet Etiketleri: </label>
                                            </div>
                                            <div className="col-lg-8">
                                                <div className="input-group">
                                                    <div className="input-group-text"><i className="feather-tag"></i></div>
                                                    <Select2WColor
                                                        value={selectedHizmetEtiketler}
                                                        key={"labelsSelect"}
                                                        options={hizmetEtiketler}
                                                        isSearchable={true}
                                                        isClearable={true}
                                                        isMulti={true}
                                                        onChange={(e) => setSelectedHizmetEtiketler(e)}
                                                        style={{ flex: 1 }}
                                                    />
                                                </div>
                                            </div>
                                        </div>
                                        <div className="row mb-4 align-items-center">
                                            <div className="col-lg-4">
                                                <label for="customerDescription" className="fw-semibold">Açıklama: </label>
                                            </div>
                                            <div className="col-lg-8">
                                                <div className="input-group">
                                                    <div className="input-group-text"><i className="feather-file-text"></i></div>
                                                    <textarea type="text" className="form-control" id="customerDescription" placeholder="Açıklama giriniz." onChange={(e) => setDesc(e.target.value)} value={desc} ></textarea>
                                                </div>
                                            </div>
                                        </div>
                                        <div className="row mb-4 align-items-center">
                                            <div className="col-lg-4">
                                                <label htmlFor="customerPhone" className="fw-semibold">Kaynak: </label>
                                            </div>
                                            <div className="col-lg-8">
                                                <div className="input-group">
                                                    <div className="input-group-text"><i className="feather-globe"></i></div>
                                                    <div style={{ flex: 1 }}>
                                                        <Select2
                                                            value={source}
                                                            key={"sourceSelect"}
                                                            options={sources}
                                                            isSearchable={true}
                                                            isClearable={true}
                                                            isMulti={false}
                                                            onChange={(e) => setSource(e)}
                                                            style={{ width: '100%' }}
                                                        />
                                                    </div>
                                                </div>
                                            </div>
                                        </div>

                                        <div className="mt-3 d-flex justify-content-start">
                                            <button onClick={createCustomer} className="btn btn-primary">
                                                <i className="feather-plus me-2"></i>
                                                <span>Müşteri Oluştur</span>
                                            </button>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

            </main>
        </Layout>
    );
}

export default CustomerCreate;